import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { useNavigate } from "react-router-dom"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import ModuleLoveMagicSpin from "./promotion_modules/modules_loveMagicSpin"

export default function LoveMagicSpin() {
  const [activeModal, setActiveModal] = useState("")

  const modalComponents = {
    "JDB Spin Tournament": ModuleLoveMagicSpin,
  }

  const ActiveModal = activeModal ? modalComponents[activeModal] : null

  const handleLoveMagicSpin = () => {
    if (!isLoggedIn) {
      window.location.href = "/promotion"
    } else {
      setActiveModal("JDB Spin Tournament")
    }
  }
  const data = promotionsData.find(
    (promo) => promo.title === "JDB Spin Tournament"
  )
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>JDB Spin Tournament</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/"> Promotions </a> / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1> JDB Spin Tournament </h1>
                <h2>
                  Win up to{" "}
                  <strong className="highlight"> 500 FREE SPINS </strong> every
                  week!
                </h2>
                <div className="promotion-tnc-period">
                  <strong> Event Period: </strong>
                  <span> February 2 (12NN) - March 2 (11:59AM) </span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                {isLoggedIn && data.title === "JDB Spin Tournament" && (
                  <div className="promotion-tnc-btn-wrapper">
                    <button
                      className="promotion-cta-btn"
                      onClick={handleLoveMagicSpin}
                    >
                      Leaderboard
                    </button>
                  </div>
                )}
                <strong>How to Join:</strong>
                <ol>
                  <li> Play JDB games during the weekly tournament period. </li>
                  <li> Earn points on total turnover. </li>
                  <li> Every ₱1,000 turnover = 1 Tournament Point. </li>
                </ol>
                <strong>Terms & Conditions</strong>
                <ol>
                  <li> One account per player. </li>
                  <li> Points are based on valid turnover only. </li>
                  <li> Tie-breaker: Player who reached the score first. </li>
                  <li>
                    {" "}
                    Any abuse or irregular play may result in
                    disqualification.{" "}
                  </li>
                  <li>
                    {" "}
                    FGH reserves the right to modify or cancel the
                    tournament.{" "}
                  </li>
                </ol>
                <div className="table-wrapper">
                  <table
                    className="promotion-tnc-table"
                    style={{ minWidth: "0" }}
                  >
                    <thead>
                      <th colSpan={3} style={{ textAlign: "center" }}>
                        Weekly Rewards
                      </th>
                    </thead>
                    <tbody>
                      <tr>
                        <td> Rank Group </td>
                        <td> FS per Player </td>
                        <td> Bet per FS </td>
                      </tr>
                      <tr>
                        <td> 1st Place </td>
                        <td> 500 FREE SPINS </td>
                        <td> 25 </td>
                      </tr>
                      <tr>
                        <td> 2nd Place </td>
                        <td> 250 FREE SPINS </td>
                        <td> 20 </td>
                      </tr>
                      <tr>
                        <td> 3rd Place </td>
                        <td> 150 FREE SPINS </td>
                        <td> 15 </td>
                      </tr>
                      <tr>
                        <td> Ranks 4-15 </td>
                        <td> 70 FREE SPINS </td>
                        <td> 10 </td>
                      </tr>
                      <tr>
                        <td> Ranks 16-25 </td>
                        <td> 50 FREE SPINS </td>
                        <td> 5 </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {ActiveModal && <ActiveModal closeModal={() => setActiveModal("")} />}
    </>
  )
}
